/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { selectStatus, selectUsers } from './users.get.slice';
import { getUsersBy } from './users.get.thunk';

export default function useGetUsersBy(fieldToSearch, extraParams) {
  const dispatch = useDispatch();

  const users = useSelector(selectUsers);
  const status = useSelector(selectStatus);

  const handleSearch = () => dispatch(getUsersBy({ searchString: fieldToSearch, extraParams: { ...extraParams } }));
  const debouncedSearch = useDebouncedCallback(handleSearch, 500);

  useEffect(() => {
    if (fieldToSearch) debouncedSearch();
  }, [fieldToSearch]);

  return {
    handleSearch,
    users,
    status,
  };
}
